import { Flex } from '@percent/lemonade'
import { DomainsTable } from '@percent/domain/iam'
import { ErrorView } from '@percent/admin-dashboard/common/components'
import { useViewableDomains } from './useViewableDomains'

export function Roles() {
  const { domains, isLoading, errorMessage } = useViewableDomains()

  if (errorMessage) {
    return <ErrorView errorMessage={errorMessage} />
  }

  return (
    <Flex direction="column" p="lg">
      <DomainsTable domains={domains} isLoading={isLoading} getDomainHref={({ id }) => `/accounts/roles/${id}`} />
    </Flex>
  )
}
